document.addEventListener("DOMContentLoaded", function() {
  var path = window.location.pathname;
  var isEnglish = path.startsWith("/en");

  document.querySelectorAll(".stock").forEach(function(el) {
    var qty = el.getAttribute("data-quantity");

    if (el.classList.contains("ready-to-ship")) {
      el.textContent = isEnglish ? "Ready to Ship" : "Klaar om te verzenden";
    }
    else if (el.classList.contains("low-stock")) {
      el.textContent = isEnglish 
        ? "Low in Stock (" + qty + " left)" 
        : "Nog maar " + qty + " op voorraad";
    } 
    else if (el.classList.contains("in-stock")) {
      el.textContent = isEnglish ? "In Stock" : "Op voorraad";
    }
  });
});